import React, {useState, useEffect} from 'react';
import {Select,Checkbox} from 'antd';
import {allFormsOfSavedObjectsPagination} from '../../../../../auth/actions/objActions';
import _ from "lodash";
import {useSelector} from "react-redux";

export default function BaseRowMultAction ({trigger,onChange}) {

    const multipleTrigger = [
        {
            value: 'row_created',
            label: "Criação de Registro"
        },
        {
            value: 'row_updated',
            label: "Atualização de Registro"
        },
        {
            value: 'row_deleted',
            label: "Remoção de Registro"
        },
    ];

    const company = useSelector((state) => state.user.company);
    const [value, setValue] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [valueMultipleTrigger, setValueMultipleTrigger] = useState([]);
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageSize: 10,
        totalPages: 1,
    });

    const fetchOptions = async (searchValue, currentPage) => {
        setLoading(true);
        const response = await allFormsOfSavedObjectsPagination({
            formName: searchValue,
            page: currentPage,
            perPage: pagination.pageSize,
            unitId:company.unitId
        });

        const transformedData = transformData(response.message);
        setData(prevData =>
            currentPage === 1 ? transformedData : [...prevData, ...transformedData]
        );

        setPagination(prev => ({
            ...prev,
            currentPage: response.pagination.currentPage,
            totalPages: response.pagination.totalPages,
        }));

        setLoading(false);
    };

    useEffect(() => {
        fetchOptions(searchTerm, 1);
    }, []);

    useEffect(() => {
        if(trigger.config && trigger.config.form){
            setValue({
                label: trigger.config.form.name,
                value: trigger.config.form.id,
            })

            if(trigger.config.multipleTrigger){
                setValueMultipleTrigger(trigger.config.multipleTrigger)
            }

        }else{
            setValue(null)
        }
    }, [trigger]);

    const handleSearchTermChange = value => {
        setSearchTerm(value);
        setPagination({...pagination, currentPage: 1});
        fetchOptions(value, 1);
    };

    const handleScroll = event => {
        const {target} = event;
        if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 100 && !loading && pagination.currentPage < pagination.totalPages) {
            const nextPage = pagination.currentPage + 1;
            setPagination(prev => ({...prev, currentPage: nextPage}));
            fetchOptions(searchTerm, nextPage);
        }
    };

    const transformData = function (data) {
        return data.map(item => ({
            label: item.name,
            value: item.id,
        }));
    };

    const handleSelectChange = (value, option) => {
        const item = data.find(item => item.value === value);
        setSelectedOption(item);
        if(item){
            onChange({
                form:{
                    name: item.label,
                    id: item.value,
                }
            })
        }
    };

    const handleChangeMultipleTrigger = (values) => {
        setValueMultipleTrigger(values)
        onChange({
            multipleTrigger:values
        })
    }

    const options = [
        {
            value: '',
            label: 'Pesquise um formulário',
            disabled: true,
        },
        ..._.uniqBy(data,'value'),
    ];

    return (
        <div>
            <div className="ae-field">
                <label className="ae-label">Ações que iniciam esta automação</label>
                <Checkbox.Group
                    options={multipleTrigger}
                    onChange={handleChangeMultipleTrigger}
                    value={valueMultipleTrigger}
                    style={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                />
            </div>
            <div className="ae-field">
            <label className="ae-label">Formulário monitorado</label>
            <Select
                loading={loading}
                style={{width: '100%'}}
                showSearch
                onSearch={handleSearchTermChange}
                onChange={handleSelectChange}
                onPopupScroll={handleScroll}
                options={options}
                filterOption={false}
                value={value}
            >
            </Select>
            </div>
        </div>
    );
}
